import { useState } from 'react';
import './FeedbackButton.css';

const FEEDBACK_LINKS = {
    telegram: 'https://t.me/whethermarket',
    bug: 'https://github.com/whether-market/whether/issues/new?template=bug_report.md&title=%5BBug%5D+',
    feature: 'https://github.com/whether-market/whether/issues/new?template=feature_request.md&title=%5BFeature%5D+',
};

function FeedbackButton() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="feedback-fab-container">
            {isOpen && (
                <div className="feedback-menu">
                    <a
                        href={FEEDBACK_LINKS.bug}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="feedback-menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        <span className="feedback-menu-icon">&#x1F41B;</span>
                        <span>Report Bug</span>
                    </a>
                    <a
                        href={FEEDBACK_LINKS.feature}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="feedback-menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        <span className="feedback-menu-icon">&#x2728;</span>
                        <span>Request Feature</span>
                    </a>
                    <a
                        href={FEEDBACK_LINKS.telegram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="feedback-menu-item"
                        onClick={() => setIsOpen(false)}
                    >
                        <span className="feedback-menu-icon">&#x2708;</span>
                        <span>Telegram</span>
                    </a>
                </div>
            )}
            <button
                className="feedback-fab"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Send feedback"
                title="Send feedback"
            >
                {isOpen ? '\u2715' : '?'}
            </button>
        </div>
    );
}

export default FeedbackButton;
